// Mock data for Gráfica Rápida Infortech

export const services = {
  grafica: [
    {
      id: 1,
      title: "Impressão Colorida e P&B",
      description: "Qualidade profissional em A4 e A3. Entrega rápida!",
      icon: "Printer"
    },
    {
      id: 2,
      title: "Cópias (Xerox)",
      description: "Preço imbatível em Fortaleza! Volume grande? Peça desconto especial.",
      icon: "Copy"
    },
    {
      id: 3,
      title: "Encadernação e Plastificação",
      description: "Acabamento premium para TCC, apostilas e documentos. Pronto hoje!",
      icon: "BookOpen"
    },
    {
      id: 4,
      title: "Impressão de Fotos 3x4",
      description: "Revelação na hora! Qualidade garantida para passaporte, CNH e documentos.",
      icon: "Camera"
    },
    {
      id: 5,
      title: "Digitalização de Documentos",
      description: "Transforme pilhas de papel em arquivos digitais. Rápido e seguro.",
      icon: "Scan"
    }
  ],
  personalizados: [
    {
      id: 6,
      title: "Adesivos e Etiquetas",
      description: "Personalize sua marca! Qualquer tamanho, qualquer quantidade. Orçamento grátis.",
      icon: "Sticker"
    },
    {
      id: 7,
      title: "Cartões de Visita",
      description: "Trabalhamos com cento ou milheiro! Impressão de qualidade que impressiona clientes.",
      icon: "CreditCard"
    },
    {
      id: 8,
      title: "Panfletos e Flyers",
      description: "Promova seu negócio! Preços especiais para grandes tiragens. Consulte já!",
      icon: "FileText"
    },
    {
      id: 9,
      title: "Pastas com Orelha",
      description: "Pastas para clínicas, consultórios, escritórios ou eventos corporativos. Acabamento premium.",
      icon: "Mail"
    },
    {
      id: 10,
      title: "Chaveiros e Canecas",
      description: "Brindes que seu cliente não esquece! Ideal para ações promocionais.",
      icon: "Gift"
    },
    {
      id: 11,
      title: "Cartazes e Banners",
      description: "Grande formato, impacto garantido! Perfeito para sua vitrine ou evento.",
      icon: "Frame"
    },
    {
      id: 12,
      title: "Carimbos Personalizados",
      description: "Carimbos automáticos personalizados para empresas, profissionais e uso pessoal.",
      icon: "Stamp",
      linkTo: "carimbos",
      featured: true
    }
  ],
  assistencia: [
    {
      id: 13,
      title: "Formatação Express",
      description: "Seu PC novo em até 3 horas! Formatação completa com Windows original.",
      icon: "HardDrive"
    },
    {
      id: 14,
      title: "Upgrade SSD e Memória",
      description: "Até 10x mais rápido! Instalação rápida. Sinta a diferença hoje.",
      icon: "Zap"
    },
    {
      id: 15,
      title: "Conserto de Notebook e PC",
      description: "Diagnóstico grátis! Reparo em até 24h. Garantia de 90 dias em todos os serviços.",
      icon: "Laptop"
    },
    {
      id: 16,
      title: "PC Lento? Resolvemos!",
      description: "Otimização profunda. Seu computador voltará a funcionar como novo.",
      icon: "Gauge"
    },
    {
      id: 17,
      title: "Recuperação de Dados",
      description: "Perdeu arquivos importantes? HD queimado? Recuperamos seus dados!",
      icon: "FolderOpen"
    },
    {
      id: 18,
      title: "Montagem de PC Gamer",
      description: "PC personalizado para você! Melhor custo-benefício de Fortaleza.",
      icon: "Cpu"
    },
    {
      id: 19,
      title: "Atendimento Domiciliar",
      description: "Não pode vir até nós? Vamos até você! Agende sua visita.",
      icon: "MapPin"
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Cris Imperial",
    text: "Precisava de 1000 panfletos com urgência. Fizeram em 3 horas com qualidade impecável! Preço honesto e atendimento nota 10.",
    rating: 5,
    date: "2024-11-15"
  },
  {
    id: 2,
    name: "Adriana Sousa",
    text: "Meu notebook não ligava. Em 1 dia estava pronto! Cobraram justo e deram garantia. Recomendo muito!",
    rating: 5,
    date: "2024-10-28"
  },
  {
    id: 3,
    name: "Gladis Marcia Pereira",
    text: "Faço todos os cartões de visita e materiais da minha empresa aqui há anos. Nunca me decepcionaram. Qualidade e rapidez sempre!",
    rating: 5,
    date: "2024-09-12"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/yht1u5mu_Caixas%20para%20aniverrs%C3%A1rioo.jpeg",
    title: "Convites de Aniversário Personalizados",
    category: "personalizados"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/1ihv5z0q_Chaveiro%20redondo.jpeg",
    title: "Chaveiros Personalizados",
    category: "personalizados"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/4hnsg74s_Calend%C3%A1rio.jpeg",
    title: "Calendário de Parede",
    category: "grafica"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/xjsxv9zt_Card%C3%A1pio.jpeg",
    title: "Cardápio Personalizado",
    category: "personalizados"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/h9ia7prm_Bloco%20autocopiativo.jpeg",
    title: "Bloco Autocopiativo",
    category: "grafica"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/lqben0yl_Banner.jpeg",
    title: "Banner Personalizado",
    category: "grafica"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/klit6mz1_Canecas.jpeg",
    title: "Caixinhas Personalizadas",
    category: "personalizados"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/fuf5zxrq_Cart%C3%A3o%20de%20visita.jpeg",
    title: "Cartões de Visita",
    category: "grafica"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/dopiyqk0_Crach%C3%A1s.jpeg",
    title: "Crachás Personalizados",
    category: "personalizados"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/ifag3fsa_Im%C3%A3.jpeg",
    title: "Ímãs de Geladeira",
    category: "personalizados"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/jacopc18_Adesivos%20redondo.jpeg",
    title: "Adesivos Personalizados",
    category: "personalizados"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/evrz0fjc_Chaveiros%203x4.jpeg",
    title: "Chaveiros Acrílicos",
    category: "personalizados"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/5xnsjmq2_Cofrinho%20para%20anivers%C3%A1rio.jpeg",
    title: "Cofrinhos Personalizados",
    category: "personalizados"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/ngkmi8ka_Panfletos%20e%20Cart%C3%B5es.jpeg",
    title: "Panfletos e Cartões",
    category: "grafica"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/1qeojqd7_Pasta%20com%20orelha.jpeg",
    title: "Pastas com Orelha",
    category: "grafica"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/rrtbeco4_Kit%20bloco%20de%20notas%20dia%20dos%20pais.jpeg",
    title: "Kit Bloco de Notas Dia dos Pais",
    category: "personalizados"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/vmnoivbh_Placa%20pvc.jpeg",
    title: "Placas em PVC",
    category: "grafica"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/fhtyfltj_Quadros.jpeg",
    title: "Quadros Decorativos",
    category: "personalizados"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/ry5absj3_Revistinhas.jpeg",
    title: "Revistinhas de Batizado",
    category: "personalizados"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/j3bed1f3_Topo%20de%20bolo.jpeg",
    title: "Topo de Bolo Personalizado",
    category: "personalizados"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/ezcijhs8_Manuten%C3%A7%C3%A3o%20de%20impressora.jpeg",
    title: "Manutenção de Impressoras",
    category: "assistencia"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/j3fghi65_Manuten%C3%A7%C3%A3o%20de%20notebook.jpeg",
    title: "Reparo de Notebooks",
    category: "assistencia"
  },
  {
    id: 23,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/htu52lls_Manuten%C3%A7%C3%A3o%20tela%20de%20notebook.jpeg",
    title: "Troca de Tela de Notebook",
    category: "assistencia"
  },
  {
    id: 24,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/4jy2bx2o_Pc%20gamer%20com%20watercooler.jpeg",
    title: "PC Gamer com Watercooler",
    category: "assistencia"
  },
  {
    id: 25,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/damxtlwf_Pc%20gamer%20montado%20gabinete%20branco.jpeg",
    title: "Montagem de PC Gamer Completo",
    category: "assistencia"
  },
  {
    id: 26,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/2103o4eg_Componentes%20pc%20gmer.jpeg",
    title: "Componentes para PC Gamer",
    category: "assistencia"
  },
  {
    id: 27,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/07ki99q8_Pc%20Gamer%20sob%20demanda%20preto.jpeg",
    title: "PC Gamer Sob Demanda",
    category: "assistencia"
  },
  {
    id: 28,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/q4i80x6m_PC%20GMER.jpeg",
    title: "PC Gamer RGB Completo",
    category: "assistencia"
  },
  {
    id: 29,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/mtiswz19_Reparo%20carca%C3%A7a%20notebook.jpeg",
    title: "Reparo de Carcaça de Notebook",
    category: "assistencia"
  },
  {
    id: 30,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/yx7olcxi_upgrade%20ssd%20e%20mem%C3%B3ria.jpeg",
    title: "Upgrade SSD e Memória",
    category: "assistencia"
  },
  {
    id: 31,
    url: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/yht1u5mu_Caixas%20para%20aniverrs%C3%A1rioo.jpeg",
    title: "Produtos para Festas",
    category: "personalizados"
  }
];

export const companyInfo = {
  name: "Gráfica Rápida Infortech e Assistência Técnica",
  shortName: "Gráfica Rápida Infortech",
  phone: "(85) 98519-5369",
  address: "Avenida Bezerra de Menezes, 1051B - Fortaleza - CE",
  rating: 4.8,
  reviewCount: 16,
  hours: "Segunda a sábado, a partir das 08:00",
  coordinates: {
    lat: -3.7408,
    lng: -38.5665
  },
  logo: {
    full: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/j2ddoafo_LOGO%20OFICIAL%20FINALIZADA_Prancheta%201_Prancheta%201.png",
    icon: "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/xl6yr60f_LOGO%20HEXAGONOS_Prancheta%201.png"
  }
};

// Papelaria items
export const papelariaItems = [
  { id: 1, name: "Papel A4", icon: "FileText" },
  { id: 2, name: "Cadernos", icon: "BookOpen" },
  { id: 3, name: "Canetas", icon: "Pen" },
  { id: 4, name: "Lápis", icon: "Pencil" },
  { id: 5, name: "Borrachas", icon: "Eraser" },
  { id: 6, name: "Marcadores", icon: "Highlighter" },
  { id: 7, name: "Pastas", icon: "FolderOpen" },
  { id: 8, name: "Envelopes", icon: "Mail" },
  { id: 9, name: "Grampeadores", icon: "Paperclip" },
  { id: 10, name: "Clips", icon: "Paperclip" },
  { id: 11, name: "Blocos", icon: "StickyNote" },
  { id: 12, name: "Calculadoras", icon: "Calculator" },
  { id: 13, name: "Materiais Escolares", icon: "GraduationCap" },
  { id: 14, name: "Materiais para Escritório", icon: "Briefcase" }
];

// Carimbos items
export const carimbosItems = [
  { id: 1, name: "Carimbo Automático", description: "Prático e rápido para uso diário" },
  { id: 2, name: "Carimbo de Bolso", description: "Compacto e portátil" },
  { id: 3, name: "Datador", description: "Ideal para controle de documentos" },
  { id: 4, name: "Numerador", description: "Numeração sequencial automática" },
  { id: 5, name: "Refil para Carimbo", description: "Tinta de qualidade e durabilidade" },
  { id: 6, name: "Borracha Personalizada", description: "Arte sob medida para sua necessidade" }
];
